// extracted by mini-css-extract-plugin
export default {"wrapper":"flyingRocketLayput_wrapper__aHt5T","firstRocket":"flyingRocketLayput_firstRocket__ORKCq","rocketMove":"flyingRocketLayput_rocketMove__lJ3nu"};